import { apiOssProxyInternal, apiOssProxyMapi } from "./api";

export type CxIdByPatientIdResponse = {
  cxId: string;
  name: string;
  location: object;
};

export async function getCxIdByPatientId(patientId: string): Promise<CxIdByPatientIdResponse> {
  const trimmedId = patientId.trim();
  if (trimmedId.length === 0) throw new Error("Patient ID is required");

  const resp = await apiOssProxyInternal.get(`/patient/${encodeURIComponent(trimmedId)}/customer`);

  if (!resp.data) throw new Error("cxId lookup response not returned");

  const cxId = resp.data.cxId;
  if (typeof cxId !== "string" || cxId.length === 0) {
    throw new Error("cxId lookup returned an invalid cxId");
  }

  return {
    cxId: resp.data.cxId,
    name: resp.data.name ?? "",
    location: resp.data.location ?? {},
  };
}

export type DocumentUrlResponse = {
  url: string;
};

export async function getDocumentPresignedUrl(
  cxId: string,
  fileName: string
): Promise<DocumentUrlResponse> {
  const resp = await apiOssProxyMapi.get(`/${cxId}/document/download-url`, {
    params: { fileName },
  });

  if (!resp.data?.url) throw new Error("Document URL not returned");

  return { url: resp.data.url };
}
